import React from 'react'
import AppButton from "../../ui/AppButton";
import Alert from "@material-ui/lab/Alert";
import Modal from "@material-ui/core/Modal";
import Redirect from "../../helpers/Redirect";
import Session from "../../helpers/Session";
import Api from "../../helpers/Api";
import Env from "../../config/env";

class AlertPrivacyPolicyDigital extends React.Component {

    state = {
        url: '',
    };

    handleAgree = async (agree) => {

        const params = {
            user: this.props.cuentas.cuentaCodigo,
            type: 'FD',
            agree: agree,
            source: Env.ApplicationCode,
        }
        const data = await Api.post(`${Env.UrlBackend}/privacy-policy/update`, params);
        if (data.success) {
            if (agree === 'S') {
                this.props.updateAgreePP();
                this.props.onCloseModal();
            } else {
                Session.logout();
                this.setState({
                    url: '/'
                });
            }
        }
    }

    handleCloseAgree = async (agree) => {
        this.props.updateCloseAgreePP();
        this.props.onCloseModal();
        return;
    }

    render() {

        const {openModal, onCloseModal, disabledClose = true, showAgreeButton = true} = this.props;

        return (
            <div>
                <Redirect url={this.state.url}/>
                <Modal
                    open={openModal}
                    onClose={onCloseModal}
                    aria-labelledby="simple-modal-title"
                    aria-describedby="simple-modal-description"
                    disableBackdropClick={disabledClose}
                    style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center'
                    }}
                >
                    <Alert style={{textAlign: 'justify', width: '600px'}}
                           severity="info">

                        <div style={{height: '500px', overflowY: 'auto'}}>
                            <div style={{paddingRight: '20px'}}>
                                <h3 style={{textAlign: 'center'}}>TÉRMINOS Y CONDICIONES FACTURA DIGITAL</h3>

                                AUTORIZACIÓN PARA LA ENTREGA POR MEDIO DE CORREO ELECTRÓNICO DE LA FACTURA DEL SERVICIO PÚBLICO 
                                DE ENERGÍA ELÉCTRICA EMITIDA POR LA ELECTRIFICADORA DEL HUILA S.A. E.S.P Y ENVÍO DE NOTIFICACIONES 
                                RELACIONADAS A LA FACTURA
                                <br/><br/>
                                <strong>Generalidades del servicio de factura digital:</strong><br/>
                                A partir de la aceptación de los términos y condiciones, EL CLIENTE, autoriza a ELECTROHUILA S.A. E.S.P. 
                                a realizar la entrega de la factura mensual o de acuerdo con el periodo de facturación, del servicio de 
                                energía eléctrica, a través del correo electrónico que registró al diligenciar esta autorización, así 
                                mismo EL CLIENTE autoriza el envío de notificaciones relacionadas a la factura, lo que incluye, pero 
                                no se limita a mensajes de texto entre otros mensajes electrónicos.
                                <br/><br/>
                                Con esta autorización, el cliente acepta que esta será la forma de entrega de su factura y por consiguiente 
                                no habrá entrega de la factura física en papel. El cliente podrá pagar a través de los medios virtuales o 
                                presenciales indicados en la factura informando su número de cuenta.
                                <br/><br/>
                                A partir de la aceptación de los términos y condiciones, ELECTROHUILA S.A E.S.P. queda facultada para entregar 
                                en la dirección electrónica suministrada, la factura del servicio de energía eléctrica mensual o de acuerdo con el 
                                periodo de facturación.
                                <br/><br/>
                                Para efectos de lo previsto en la Ley 142 de 1994 y el Contrato de Servicio público de Energía Eléctrica, se 
                                entenderá que el Cliente ha recibido la factura en la fecha y hora en que el Cliente reciba el correo electrónico 
                                remitido por ELECTROHUILA S.A E.S.P. en el buzón del correo electrónico que registró al diligenciar esta autorización.
                                <br/><br/>
                                Dicho envío y recepción de los correos electrónicos generados en desarrollo de la presente autorización serán 
                                certificados con plena validez jurídica por la empresa autorizada por ELECTROHUILA S.A ESP. El envío de la factura 
                                mensual de energía eléctrica al correo electrónico del cliente en las condiciones señaladas en este documento, tendrá 
                                los mismos efectos de la entrega en físico y/o en papel que se realiza en la dirección del inmueble donde se presta 
                                el servicio de energía.
                                <br/><br/>

                                <strong>Compromisos del Cliente:</strong> EL CLIENTE se hace responsable de adoptar las medidas de seguridad idóneas para la administración de la cuenta de correo electrónico, así como del manejo de la clave de ingreso al mismo y de mantener el buzón con la capacidad suficiente para la recepción de la factura mensual del servicio de energía eléctrica emitida por ELECTROHUILA S.A. ESP. En consecuencia, la omisión en el cumplimiento de dicha obligación por parte del cliente no invalidará la entrega realizada por este medio.
                                <br/><br/>
                                El cliente será responsable de revisar el buzón del correo electrónico indicado, razón por la cual la omisión en el cumplimiento de dicha obligación por parte del cliente no invalidará la entrega realizada por este medio.
                                <br/><br/>
                                Las facturas mensuales de energía eléctrica emitidas por ELECTROHUILA S.A. ESP., serán remitidas para su visualización, en formato PDF, razón por la cual EL CLIENTE deberá tener instalado en su equipo el software que permita la correcta visualización y/o descarga de las imágenes que remita ELECTROHUILA S.A ESP en ese formato.
                                <strong>Vigencia de la autorización:</strong> A partir del Registro en la plataforma, lo que implica la aceptación de los términos y condiciones, ELECTROHUILA S.A ESP enviará la factura al correo electrónico registrado y hasta tanto EL CLIENTE comunique en cualquier momento por los canales virtuales o los canales de su preferencia a ELECTROHUILA S.A ESP, que el envío y entrega de facturas sucesivas no se realicen por correo electrónico. Dicha comunicación tendrá efectos a partir del periodo de facturación siguiente.
                                <br/><br/>
                                <strong>Autorización para el tratamiento de datos personales:</strong>
                                <br/><br/>
                                ELECTROHUILA SA ESP, con domicilio social en Neiva, Colombia, identificada con el número de NIT 891.180.001-1, actuando en su calidad de Responsable del Tratamiento, procesará los datos personales que son proporcionados de acuerdo con las disposiciones vigentes, establecidas en la legislación colombiana sobre tratamiento y protección de datos personales, en especial, por lo dispuesto en la Ley 1581 de 2012 y en el Decreto 1074 de 2015, y demás normas concordantes, la Política de Tratamiento de Datos Personales de ELECTROHUILA S.A. ESP vigente y los presentes términos y condiciones.
                                ELECTROHUILA SA ESP garantiza las condiciones de seguridad, privacidad y demás principios que impliquen el tratamiento de datos personales. El suministro de sus Datos Personales es necesario para el disfrute del beneficio de Factura digital. Su denegación es voluntaria, sin embargo, sobreviene la imposibilidad para Electrohuila S.A. ESP de llevar a cabo el fin para el que se recopilan los Datos Personales, por lo cual no se podrá llevar a cabo el Registro.
                                En virtud de lo consagrado en el art. 28 de la Ley 1581 de 2012, en relación con los Datos Personales comunicados, usted tiene derecho a:
                                <br/><br/>
                                a)	Conocer, actualizar y rectificar sus datos personales frente a los Responsables del Tratamiento o Encargados del Tratamiento. Este derecho se podrá ejercer, entre otros frente a datos parciales, inexactos, incompletos, fraccionados, que induzcan a error, o aquellos cuyo Tratamiento esté expresamente prohibido o no haya sido autorizado;
                                <br/>
                                b)	Solicitar prueba de la autorización otorgada al Responsable del Tratamiento salvo cuando expresamente se exceptúe como requisito para el Tratamiento, de conformidad con lo previsto en la ley;
                                <br/>
                                c)	Ser informado por el Responsable del Tratamiento o el Encargado del Tratamiento, previa solicitud, respecto del uso que les ha dado a sus datos personales;
                                <br/>
                                d)	Presentar ante la Superintendencia de Industria y Comercio quejas por infracciones a lo dispuesto en la presente ley y las demás normas que la modifiquen, adicionen o complementen;
                                <br/>
                                e)	Revocar la autorización y/o solicitar la supresión del dato cuando en el Tratamiento no se respeten los principios, derechos y garantías constitucionales y legales. La revocatoria y/o supresión procederá cuando la Superintendencia de Industria y Comercio haya determinado que en el Tratamiento el Responsable o Encargado han incurrido en conductas contrarias a esta ley y a la Constitución;
                                <br/><br/>
                                Para peticiones, reclamos y consultas relativas a sus derechos como Titular de los Datos Personales, se debe realizar una solicitud adjuntando como información datos sobre la identificación del Titular, la descripción de los hechos que dan lugar a la petición reclamo o consulta, la dirección donde quiere ser notificado, y acompañando los documentos que se quiera hacer valer, en los canales de atención que se describen en la política que podrá encontrar en www.electrohuila.com.co.
                                <br/><br/>
                                En su condición de Titular de los datos personales proporcionados en el momento del Registro en la plataforma, consiente y autoriza de manera expresa e inequívoca que, conforme a la ley 1581 del 2012, Electrohuila S.A. ESP trate sus datos para todos los fines relacionados con sus productos activos y la prestación del servicio público de energía eléctrica, en los términos del contrato de servicio público, la Ley 142 de 1994 y la política de tratamiento de datos personales. Lo que incluye la entrega de la factura mensual o de acuerdo con el periodo de facturación, del servicio de energía eléctrica, a través del correo electrónico que registró al diligenciar esta autorización, y el envío de notificaciones relacionadas a la factura, lo que incluye, pero no se limita a mensajes de texto entre otros mensajes electrónicos.
                                <br/><br/>

                                <strong>Aceptación de la autorización:</strong> Declaro haber leído y entendido la totalidad de los términos y condiciones y los acepto al momento de realizar el Registro.

                            </div>
                        </div>

                        <table style={{width: '100%', textAlign: 'center'}}>
                            <tbody>
                            <tr>
                                <td>
                                    {
                                        showAgreeButton ?
                                            <span style={{padding: '5px'}}>
                                            <AppButton
                                                type='button'
                                                label='Si acepto'
                                                size='small'
                                                onClick={() => {
                                                    this.handleAgree('S')
                                                }}
                                            />
                                        </span> : null
                                    }

                                    <span style={{padding: '5px'}}>
                                    <AppButton
                                        type='button'
                                        label='No acepto'
                                        size='small'
                                        onClick={() => {
                                            this.handleCloseAgree('N')
                                        }}
                                    />
                                </span>

                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </Alert>

                </Modal>
            </div>
        );
    }

}

export default AlertPrivacyPolicyDigital

